import {
  Users,
  Calendar,
  MessageCircleQuestion,
  Briefcase,
  Orbit,
  Contact,
  ShoppingBag,
  Coffee,
  ShieldCheck,
  type LucideIcon,
} from "lucide-react";
import { conciergeGeneralHref } from "@/lib/concierge";

export type NavSectionRoute =
  | "/people"
  | "/events"
  | "/requests"
  | "/work"
  | "/circles"
  | "/marketplace"
  | "/coffee";

export type NavSection = {
  key: string;
  label: string;
  Icon: LucideIcon;
  to?: NavSectionRoute;
  search?: { experts?: boolean };
  soon?: boolean;
  /** Внешняя ссылка (открывается в новой вкладке). */
  href?: string;
};

/** Единый список разделов: нижняя панель, «Ещё», полка на главной, десктопное меню. */
export const NAV_SECTIONS: NavSection[] = [
  { key: "events", label: "Афиша", Icon: Calendar, to: "/events" },
  { key: "circles", label: "Сообщества", Icon: Orbit, to: "/circles" },
  { key: "experts", label: "Эксперты", Icon: Contact, to: "/people", search: { experts: true } },
  { key: "people", label: "Знакомства", Icon: Users, to: "/people" },
  { key: "coffee", label: "Кофе", Icon: Coffee, to: "/coffee" },
  { key: "requests", label: "Спроси своих", Icon: MessageCircleQuestion, to: "/requests" },
  { key: "work", label: "Работа", Icon: Briefcase, to: "/work" },
  { key: "marketplace", label: "Барахолка", Icon: ShoppingBag, to: "/marketplace" },
  { key: "prive-concierge", label: "PRIVE консьерж-сервис", Icon: ShieldCheck, href: conciergeGeneralHref(null, "menu") },
];

/** Сколько разделов помещается в нижнюю панель (после «Главной»). */
export const BOTTOM_TAB_SECTION_COUNT = 3;

/** Маршруты, при которых подсвечивается «Ещё» (/people — только без режима экспертов). */
export const MORE_ROUTES = new Set(["/people", "/coffee", "/requests", "/work", "/marketplace", "/profile", "/arena/people"]);

/** Какая вкладка нижней панели активна: "home" | ключ раздела | "more" | null. */
export function activeTabKey(pathname: string, experts: boolean): string | null {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === "/home") return "home";
  if (path === "/people") return experts ? "experts" : "more";
  if (path.startsWith("/people/")) return null;
  for (const s of NAV_SECTIONS.slice(0, BOTTOM_TAB_SECTION_COUNT)) {
    if (s.to && s.to !== "/people" && (path === s.to || path.startsWith(s.to + "/"))) return s.key;
  }
  if (MORE_ROUTES.has(path) || [...MORE_ROUTES].some((r) => path.startsWith(r + "/"))) return "more";
  return null;
}
